import { SubtitleH3 as BluBlocksSubtitleH3 } from "@bluframe/blublocks"
import styled from "styled-components"
import mediaQueries from "styles/mediaQueries"

const SubtitleH3 = styled(BluBlocksSubtitleH3)`
  font-size: 14px;
  font-weight: 700;
  margin: 0;

  ${mediaQueries.tablet} {
    font-size: 16px;
  }
`

export default SubtitleH3
